export default "__VITE_ASSET__CoG$REwl__"